import habitat from "preact-habitat";
import Widget from "./components/Widget";
import "./styles/tailwind.css";
var _habitat = habitat(Widget);
_habitat.render({
    // selector: '[data-widget-host="habitat"]',
    selector: '[data-widget="kirahub"]',
    clean: true
});
